module.exports = __webpack_public_path__ + "img/base_dark.7a30c8b6.png";